import { enums, integer, nullable, object, optional, string } from 'superstruct';
import { stringDate } from '@arc/shared/util-superstruct';

// Enum constants matching the Prisma schema
const AWS_ARC_CLEANUP_RESOURCE_TYPES = ['STACK', 'RDS', 'EFS', 'LOG_GROUP'];
export const CLEANUP_STATUSES = ['QUEUED', 'ERROR'];
export const ViewCleanupTaskDto = object({
  id: integer(),
  resourceName: string(),
  resourceArn: string(),
  resourceType: enums(AWS_ARC_CLEANUP_RESOURCE_TYPES),
  status: enums(CLEANUP_STATUSES),
  deleteAt: stringDate(),
  error: optional(nullable(string())),
  createdAt: stringDate(),
  updatedAt: stringDate()
});